module.exports = __webpack_public_path__ + "img/eth.2d24bcec.svg";